import request from '@/router/axios'

const API = '/api/produce/kanban/device-alarm-count-stats'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

function n(v) {
  const x = Number(v)
  return Number.isFinite(x) ? x : 0
}

function filled(v) {
  return v !== undefined && v !== null && v !== ''
}

export function fetchDeviceAlarmCountStats(params = {}) {
  const data = {
    alertType: filled(params.alertType) ? params.alertType : undefined,
    type: filled(params.type) ? params.type : undefined,
    alertStatus: filled(params.alertStatus) ? Number(params.alertStatus) : undefined,
    category: filled(params.category) ? params.category : undefined
  }
  if (params.startTime != null) data.startTime = params.startTime
  if (params.endTime != null) data.endTime = params.endTime
  return request({ url: API, method: 'post', data }).then(unwrap).then(normalize)
}

function normalize(d) {
  if (!d || typeof d !== 'object') {
    return {
      kpi: { totalCount: 0, todayCount: 0, openCount: 0, level1OpenCount: 0 },
      byCategory: [],
      byType: [],
      byAlertType: [],
      byStatus: [],
      matrixCells: []
    }
  }
  const k = d.kpi || {}
  return {
    kpi: {
      totalCount: n(k.totalCount),
      todayCount: n(k.todayCount),
      openCount: n(k.openCount),
      level1OpenCount: n(k.level1OpenCount)
    },
    byCategory: mapBuckets(d.byCategory),
    byType: mapBuckets(d.byType),
    byAlertType: mapBuckets(d.byAlertType),
    byStatus: mapBuckets(d.byStatus),
    matrixCells: (d.matrixCells || []).map((c) => ({
      rowKey: c.rowKey,
      colKey: c.colKey,
      cellValue: n(c.cellValue)
    }))
  }
}

function mapBuckets(list) {
  return (list || []).map((b) => ({
    bucketName: b.bucketName,
    bucketValue: n(b.bucketValue)
  }))
}
